
import * as THREE from 'three';
import { useLoader } from '@react-three/fiber/dist/react-three-fiber.cjs';
import { useThree, useFrame } from '@react-three/fiber'
import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// moblile 
// camera: [180,0-70]
// earth 2


const RADIUS = 5;
function EarthGeometry({planePosition,divRef,earthGroupRef,setPlanePosition,rotationY, canvasRef, isOrbiting, showModal}) {
    const maskTexture = useLoader(THREE.TextureLoader, '/data-earth.png'); 
    const baseColor = new THREE.Color(0x639bb0); // Base color of the sphere
    const overlayColor = new THREE.Color(0x639bb0); // Load your mask texture
    const materialRef = useRef();
    // const [scrollProgress, setScrollProgress] = useState(0); 
    const scrollValue = useRef(0);
    const meshRef = useRef()
    // const {camera} = useThree()
  

    // useEffect(() => {
    //     if(earthGroupRef.current) {

    //         // GSAP animation triggered on scroll
    //         const timeline = gsap.timeline({
    //           scrollTrigger: {
    //             trigger: '.hero-section',
    //             id:"hero",
    //             markers: true, // The container you want to pin
    //             start: 'top top', // Start pinning when the top of the section reaches the top of the viewport
    //             end: '+=100%', // How far you want the scroll effect to go
    //             scrub: true, // Smooth scroll effect
    //             onUpdate:function (self){
    //               console.log("camera, ", camera.rotation)
    //               // _x: -2.827433388230814
    //               // _y: 1.1647083184890926e-16
    //               // _z: 3.141592653589793
    //             },
    //             onanimationstart: ()=>{
                 
    //             }
    //             // pin: true, // Pin the hero section during the scroll
    //           },
    //         });

    //         // Animate earthGroupRef along a cubic bezier curve
    //         // timeline.to(earthGroupRef.current.position, {
    //         //   bezier: {
    //         //     type: "cubic",             // Smooth cubic bezier curve
    //         //     values: [
    //         //       { x: 0, y: 0, z: 0 },   // Starting position
    //         //       { x: -4, y: 3, z: 22 }, // Control point for the arc
    //         //       { x: -7, y: 0, z: 45 }, // Ending position
    //         //     ],
    //         //   },
    //         //   duration: 3,                 // Duration in seconds (not needed when using ScrollTrigger)
    //         //   ease: 'power1.inOut',        // Smooth easing
    //         // });
    //         timeline.to(camera.position, {
    //           x: 0,
    //           y: 0,     // Set the rotation value for y-axis (adjust as needed)
    //           z: 100,     // Set the rotation value for z-axis (adjust as needed)
    //           duration: 0.2,  // Duration of the animation (optional)
    //         });
    //      // Move both the earth group and camera at the same time
    //           timeline.to(earthGroupRef.current.position, 
    //             {x:-8, duration: 1,
    //             ease: 'power1.inOut',
    //             onStart: () => {
    //               // Reset the camera's position and rotation to the world-aligned values
    //               // camera.position.set(0, 0, 100);  // or any default position you want
    //               // camera.rotation.set(0, 0, 0);   // Reset rotation to the world-aligned state
    //             },
    //           })
    //           // .add(
    //           //   gsap.to(camera.position, {
    //           //     z: 100, // Move the camera
    //           //     duration: 1,
    //           //     ease: 'linear',
    //           //   }),
    //           //   0 // This ensures the camera animation starts at the same time as the previous animation
    //           // )
    //           .add(
    //             gsap.to(earthGroupRef.current.position, {
    //               z:45,// Animate the scroll value from 0 to 1
    //               ease: "power1.inOut",
    //             }),
    //             0
    //           )
    //           .add(
    //             gsap.to(earthGroupRef.current.position, {
    //               y:-1,// Animate the scroll value from 0 to 1
    //               ease: "power1.inOut",
    //             }),
    //             0
    //           )
    //           .add(
    //             gsap.to(scrollValue, {
    //               current: 1, // Animate the scroll value from 0 to 1
    //               ease: "linear",
    //               duration: 1,
    //             }),
    //             0
    //           );

    //         // gsap.timeline({
    //         //     scrollTrigger: {
    //         //       trigger: '.why-us', // The container you want to pin
    //         //       start: '-=60%', // Start pinning when the top of the section reaches the top of the viewport
    //         //       end:"25%",
    //         //       id:"why-us",
    //         //       scrub: true, // Smooth scroll effect
    //         //       markers: true
    //         //       // pin: true, // Pin the hero section during the scroll
    //         //     },
    //         //   })
    //         //   .to(earthGroupRef.current.position, {
    //         //     x: -6, // Move the geometry to the right
    //         //   duration: 1,
    //         //   ease: 'linear',
    //         //   })
              
              gsap.timeline({
                scrollTrigger: {
                  trigger: '.why-us', 
                  start: '-50%',
                  end:"100%",
                  id:"why-us",
                  // scrub: true,
                  // markers: true,
                  onLeave: ({progress, direction, isActive}) => canvasRef.current.classList.remove("blur") ,
                  onLeaveBack: ({progress, direction, isActive}) => canvasRef.current.classList.remove("blur"),
                  onEnterBack: ({progress, direction, isActive}) => canvasRef.current.classList.add("blur"),
                  onEnter: ({progress, direction, isActive}) => canvasRef.current.classList.add("blur") 
                },
              })
    // .to(earthGroupRef.current.position, {
    //                 x:0,
    //                 duration: 1,
    //                 ease: 'linear',
    //               })
    //           // gsap.timeline({
    //           //   scrollTrigger: {
    //           //     trigger: '.why-us',
    //           //     start: '100%',
    //           //     id:"why-us-2",
    //           //     scrub: true, 
    //           //     markers: true,
    //           //     onLeave: ({progress, direction, isActive}) => canvasRef.current.classList.add("blur") ,
    //           //     onEnterBack: ({progress, direction, isActive}) => canvasRef.current.classList.remove("blur")
    //           //   },
    //           // })
        
    //         return () => {
    //           // Clean up GSAP ScrollTrigger when component unmounts
    //           ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    //         };

    //     }
    //   }, [camera]);
   
    useFrame(() => {
        if (materialRef.current) {
            // materialRef.current.uniforms.divYPosition.value = scrollValue.current;
            // materialRef.current.needsUpdate = true; // Ensure the material updates
            // console.log("materialRef.current.uniforms.divYPosition.value: ",materialRef.current.uniforms.divYPosition.value)
            // console.log("camera.position: ",camera.position)
            // if(meshRef.current && scrollRef.current > 0.5) {
            //     meshRef.current.position.x = scrollRef.current * 5
            //     camera.position.x = scrollRef.current * 5
            // }
        }
        if (!isOrbiting && !showModal && earthGroupRef.current) {
          earthGroupRef.current.rotation.y += 0.001; // Adjust the speed as needed
        }
    });
    return (
        <mesh ref={meshRef}>
          <sphereGeometry  args={[RADIUS, 256, 256]}/>
          <shaderMaterial
                transparent={true}
                depthWrite={false} 
                ref={materialRef}
                side={THREE.DoubleSide}
                vertexShader={`
                varying vec2 vUv;
                varying vec3 vWorldPosition;
                void main() {
                    vUv = uv;

                    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
                    vWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;
                    gl_Position = projectionMatrix * mvPosition;
                    gl_PointSize = 0.01; // Adjust point size as needed


                    // Use the worldMatrix to calculate the correct world space position
                    // vec4 worldPosition = modelMatrix * vec4(position, 1.0);
                    // vWorldPosition = (viewMatrix * worldPosition).xyz;  // Transform to camera space
                    // gl_Position = projectionMatrix * vec4(vWorldPosition, 1.0);
                    // gl_PointSize = 0.01; // Adjust point size as needed
                }
                `}
                fragmentShader={`
                uniform sampler2D maskTexture;
                uniform vec3 overlayColor;
                uniform vec3 pointColor;
                uniform float pointSize;
                varying vec2 vUv;
                varying vec3 vWorldPosition;
                uniform float divYPosition;

                void main() {
                    vec4 maskColor = texture2D(maskTexture, vUv);
                    // vec3 dynamicColor = mix(pointColor ,overlayColor , divYPosition);
                    // Normalize vertex height (assuming Y goes from -1 to 1)
                    // float normalizedHeight = (vWorldPosition.y + 5.0 - divYPosition * 11.0);
                
                    // Choose color based on height relative to divYPosition for a sharp transition
                    // vec3 dynamicColor = (normalizedHeight < divYPosition) ? overlayColor: pointColor  ;
                    
                    if (maskColor.r < 0.1) {
                      gl_FragColor = vec4(pointColor,0.4);
                      // if(divYPosition > 0.5) {
                      //   float min = clamp(1.4 - divYPosition, 0.6, 1.4);
                      // } else {
                      //   gl_FragColor = vec4(pointColor, 0.9);
                      // }
                        
                    } else {
                        gl_FragColor = vec4(0.012,0.012,0.129,0.0);
                    }
                }
                `}
                uniforms={{
                pointColor: { value: baseColor }, // Color of the points
                pointSize: { value: 0.00001 }, // Size of the points
                maskTexture: {value: maskTexture},
                overlayColor: { value: overlayColor },
                divYPosition: { value: scrollValue.current }
                }}
            />
        </mesh>
    );
  }
  
  export default EarthGeometry